import { Link } from 'react-router-dom';
import { CONTEXT_HELP, findHelpTopic, resolveHelpText, tx, type HelpScreen } from '@fsv/data';
import { Icon } from '../components/Icon';
import { useOptionalTenant } from '../data/hooks';
import { tenantPath } from '../lib/tenantRouting';

/** `/hilfe[/topic]`, inside a club `/v/<slug>/hilfe[/topic]` (keeps the club's navigation around it). */
export function helpPath(slug: string | null | undefined, topic?: string): string {
  const base = slug ? tenantPath(slug, '/hilfe') : '/hilfe';
  return topic ? `${base}/${topic}` : base;
}

/**
 * The "?" on a screen: opens the topic that explains it (CONTEXT_HELP, the
 * same table the app uses). Without `screen` it opens the help's index.
 */
export function HelpLink({
  screen,
  className = '',
  tour,
}: {
  screen?: HelpScreen;
  className?: string;
  tour?: string;
}) {
  const tenant = useOptionalTenant();
  const topic = screen ? findHelpTopic(CONTEXT_HELP[screen]) : null;
  const label = topic ? tx.help.contextLabel(resolveHelpText(topic.title)) : tx.help.open;
  return (
    <Link
      to={helpPath(tenant?.slug, topic?.id)}
      className={`btn btn--ghost btn--icon help-link ${className}`}
      aria-label={label}
      title={label}
      data-tour={tour}
    >
      <Icon name="help" />
    </Link>
  );
}
